import { render, staticRenderFns } from "./EventPostEditView.vue?vue&type=template&id=b182a9d2&scoped=true&"
import script from "./EventPostEditView.vue?vue&type=script&lang=ts&"
export * from "./EventPostEditView.vue?vue&type=script&lang=ts&"
import style0 from "./EventPostEditView.vue?vue&type=style&index=0&id=b182a9d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b182a9d2",
  null
  
)

export default component.exports